module.exports = __webpack_public_path__ + "static/media/editor-icon-italic.e00c8cce.svg";